// This file was auto-generated by Fern from our API Definition.
const ErrorSeverityValues = {
    Critical: "CRITICAL",
    Warning: "WARNING",
};
export const ErrorSeverity = Object.assign(Object.assign({}, ErrorSeverityValues), { _visit: (value, visitor) => {
        switch (value) {
            case ErrorSeverity.Critical:
                return visitor.critical();
            case ErrorSeverity.Warning:
                return visitor.warning();
            default:
                return visitor._other();
        }
    } });
